import styled from 'styled-components';

export const PageTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${(p) => p.theme.white};
  margin-bottom: 20px;
`;
